import { experimentalStyled } from "@mui/material";
import CButton from "./CButton";

const InLineButton = experimentalStyled(CButton)(() => ({
  minWidth: 150,
}));

const ContainedButton = (props) => {
  const { children, onClick, ...rest } = props;

  return (
    <InLineButton
      {...rest}
      onClick={onClick}
      color="primary"
      variant="contained"
    >
      {children}
    </InLineButton>
  );
};

const ContainedSecondaryButton = (props) => {
  const { children, onClick, ...rest } = props;

  return (
    <InLineButton
      {...rest}
      onClick={onClick}
      color="secondary"
      variant="contained"
    >
      {children}
    </InLineButton>
  );
};

const OutlinedButton = (props) => {
  const { children, onClick, ...rest } = props;

  return (
    <InLineButton
      {...rest}
      onClick={onClick}
      color="primary"
      variant="outlined"
    >
      {children}
    </InLineButton>
  );
};

export { ContainedButton, ContainedSecondaryButton, OutlinedButton };
